var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BarChart',{attrs:{"title":"Total Sales - Last 30 Days","fetchData":_vm.getSalesReport,"series":_vm.series,"chartId":"totalSalesLast30Days","csvFilename":"Total Sales - Last 30 Days","headerCategory":"Date"},on:{"error":_vm.handleError}})}
var staticRenderFns = []

export { render, staticRenderFns }